import React from 'react'
import { Box, Grid, Paper, Typography, Checkbox } from '@mui/material'
import DOMPurify from 'dompurify'
import Avatar from '@/Components/Elements/Avatar'
import { MessageContentProps } from './types'

const MessageContent: React.FC<MessageContentProps> = ({
    item,
    filter,
    kedo,
    hasCheckedItem,
    updateCheckedStatus,
    handleItemClick,
}) => {
    const isChecked = Boolean(hasCheckedItem(item))
    const isUnread = !item.read_date && filter !== 'outgoing'

    return (
        <Paper
            key={item.id}
            elevation={isUnread ? 3 : 1}
            sx={{
                mb: 1,
                p: 1.5,
                cursor: 'pointer',
                bgcolor: isUnread ? 'action.hover' : 'background.paper',
            }}
        >
            <Grid container spacing={2} alignItems="flex-start">
                <Grid size="auto">
                    <Checkbox
                        checked={isChecked}
                        onChange={(event) => updateCheckedStatus(event, item)}
                    />
                </Grid>

                <Grid size="auto">
                    <Avatar
                        name={item.sender_name}
                        kedo={kedo}
                        user={{
                            userId: item.sender_id,
                            username: item.sender_name,
                        }}
                        options={{
                            size: 38,
                            showPresence: false,
                        }}
                        props={{ kedo }}
                    />
                </Grid>

                <Grid size="grow" onClick={() => handleItemClick(item.id)}>
                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                    >
                        <Typography
                            variant="subtitle2"
                            className="badge badge-primary"
                            fontWeight={isUnread ? 600 : 400}
                        >
                            {item.sender_name}
                        </Typography>

                        <Typography
                            variant="caption"
                            className="badge badge-secondary"
                            sx={{
                                color: (theme) => theme.palette.common.white,
                            }}
                        >
                            {kedo.utils().dateFormat(item.created_at)}
                        </Typography>
                    </Box>

                    <Typography
                        variant="subtitle1"
                        fontWeight={isUnread ? 600 : 400}
                        noWrap
                    >
                        {item.title}
                    </Typography>

                    <Box
                        className="readMore messageOverview"
                        dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(item.message_text),
                        }}
                    />
                </Grid>
            </Grid>
        </Paper>
    )
}

export default MessageContent
